import './deliveryPersonSelect.css';

/**
 * Rattache la liste au conteneur positionné du champ, à l'intérieur du modal.
 * Elle reste ainsi dans la même zone de défilement et de gestion du focus
 * que la recherche, au lieu d'être ajoutée directement au corps de la page.
 */
function getDeliveryPersonPopupContainer(triggerNode) {
  // Ant Design positionne ce conteneur en relatif : la liste reste alignée avec le champ.
  return triggerNode.closest('.ant-form-item-control-input') || triggerNode.parentElement;
}

/**
 * Fournit les réglages communs aux trois sélecteurs de livreurs des commandes.
 * Sur mobile, toutes les options restent dans le DOM et le navigateur gère
 * le défilement tactile natif, dans une liste limitée à 224 pixels de hauteur.
 * Sur ordinateur, la virtualisation et la hauteur habituelle sont conservées.
 */
export function getDeliveryPersonSelectProps(isMobile) {
  return {
    virtual: !isMobile,
    listHeight: isMobile ? 224 : 256,
    getPopupContainer: getDeliveryPersonPopupContainer,
    popupClassName: 'delivery-person-select-dropdown',
  };
}
